<template>
    <div class="window-wrapper window-contact-section-delete">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Вы действительно хотите удалить это контактное лицо?</div>
                    <div class="button-block">
                        <button @click="confirm" class="button button-dark button-close-window contact-section-delete">Да</button>
                        <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DeleteContactWindow",

        methods: {
            confirm() {
                this.$emit('removeContact');
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            },
            closeWindow() {
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            }
        }
    }
</script>

<style scoped>

</style>